import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

const getTalkingPointBriefResponse = (response) => {
  const result = response?.data?.talkingPoint ?? {};

  if (!isEmpty(result) || !isEmpty(result?.productHighlights)) 
    return {
    ...result,
    productHighlights: {
      items: result?.productHighlights,
      startedAt: moment(result?.startedAt).format('DD MMM YY'),
      endedAt: moment(result?.endedAt).format('DD MMM YY'),
    },
  };

  return result
};

export default getTalkingPointBriefResponse;
